import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var NumberedListSvg = function NumberedListSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.25 0c0 .932-.805 1.75-1.875 1.75H4.5v1.5h.875c.687 0 1.335-.2 1.875-.548V9.25H4.5v1.5h7v-1.5H8.75V0zM4.25 15.313c0-1.14.923-2.063 2.063-2.063h3.375c1.138 0 2.062.923 2.062 2.062v1.455c0 .82-.485 1.56-1.236 1.89l-4.427 1.936a.56.56 0 0 0-.337.515v1.142H12v1.5H4.25v-2.642c0-.82.485-1.56 1.236-1.89l4.427-1.936a.56.56 0 0 0 .337-.515v-1.455a.56.56 0 0 0-.562-.562H6.312a.56.56 0 0 0-.562.563v.938h-1.5zM15.688 6.25c-1.14 0-2.063.923-2.063 2.063v.938h1.5v-.938c0-.311.252-.563.563-.563h2.624c.311 0 .563.252.563.562v1.5c0 .311-.252.563-.562.563h-3.065v1.5h3.44c.31 0 .562.252.562.562v2.25c0 .311-.252.563-.562.563h-3.375a.56.56 0 0 1-.563-.562v-.938h-1.5v.938c0 1.139.923 2.062 2.063 2.062h3.374c1.14 0 2.063-.923 2.063-2.062v-2.25c0-.61-.265-1.159-.686-1.536.197-.316.311-.69.311-1.09v-1.5c0-1.139-.923-2.062-2.062-2.062z"
  }));
};
export var NumberedList = function NumberedList(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: NumberedListSvg
  }));
};